import AssessmentServiceApi from "../../services/assessment-api";

const updateUserPassword = (data) => {
  return function () {
    return AssessmentServiceApi.updateUserPassword(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Password Update Error:", error));
  };
};

export { updateUserPassword };
